import { createReducer } from 'typesafe-actions'
import { Reducer } from 'redux'
import {
  EstimatesState,
  EstimatesAction,
  EstimatesActionTypes
} from './types'

export const initialState: EstimatesState = {
  isFetchingCreate: false,
  isFetching: false,
  // @ts-ignore
  data: {},
  estimate: {},
  error: false,
  isFetchingCreatePublic: false,
  publicEstimate: {}
}

// @ts-ignore
export const estimatesReducer: Reducer<EstimatesState> = createReducer<
  EstimatesState,
  EstimatesAction
>(initialState, {
  [EstimatesActionTypes.CREATE_ESTIMATE_REQUEST]: (state: EstimatesState) => ({
    ...state,
    isFetchingCreate: true,
    error: false
  }),
  [EstimatesActionTypes.CREATE_ESTIMATE_SUCCESS]: (state: EstimatesState) => ({
    ...state,
    isFetchingCreate: false,
    error: false
  }),
  [EstimatesActionTypes.CREATE_ESTIMATE_FAIL]: (state: EstimatesState) => ({
    ...state,
    isFetchingCreate: false,
    error: true
  }),
  [EstimatesActionTypes.CREATE_PUBLIC_ESTIMATE_REQUEST]: (
    state: EstimatesState
  ) => ({
    ...state,
    isFetchingCreatePublic: true,
    error: false
  }),
  [EstimatesActionTypes.CREATE_PUBLIC_ESTIMATE_SUCCESS]: (
    state: EstimatesState,
    action: any
  ) => ({
    ...state,
    isFetchingCreatePublic: false,
    error: false,
    publicEstimate: { ...action.payload.estimate.data }
  }),
  [EstimatesActionTypes.CREATE_PUBLIC_ESTIMATE_FAIL]: (
    state: EstimatesState
  ) => ({
    ...state,
    isFetchingCreatePublic: false,
    error: true
  }),
  [EstimatesActionTypes.FETCH_ESTIMATES_SUCCESS]: (
    state: EstimatesState,
    action: EstimatesAction
  ) => ({
    ...state,
    isFetchingCreate: true,
    // @ts-ignore
    data: action.payload
  }),
  [EstimatesActionTypes.FETCH_ESTIMATE_REQUEST]: (state: EstimatesState) => ({
    ...state,
    isFetching: true
  }),
  [EstimatesActionTypes.FETCH_ESTIMATE_SUCCESS]: (
    state: EstimatesState,
    action: EstimatesAction
  ) => {
    console.log('action', action)
    // @ts-ignore
    let dob = action.payload.dob
    // @ts-ignore
    let dependentEntityDob = action.payload.dependentEntity && action.payload.dependentEntity.dob
    if (dob) {
      const oldDate = dob.split('-')
      const [y, m, d] = oldDate
      const newDate = [m, d, y]
      dob = newDate.join('/')
    }
    if (dependentEntityDob) {
      const oldDate = dependentEntityDob.split('-')
      const [y, m, d] = oldDate
      const newDate = [m, d, y]
      dependentEntityDob = newDate.join('/')
    }
    console.log('dob', dob, dependentEntityDob)
    return {
      ...state,
      isFetching: false,
      estimate: {
        // @ts-ignore
        ...action.payload,
        dob,
        dependentEntity: {
          // @ts-ignore
          ...action.payload.dependentEntity,
          dob: dependentEntityDob
        }
      }
    }
  },
  [EstimatesActionTypes.FETCH_ESTIMATE_FAIL]: (
    state: EstimatesState,
    action: EstimatesAction
  ) => ({
    ...state,
    isFetching: false
  }),
  [EstimatesActionTypes.GET_PDF_REQUEST]: (state: EstimatesState) => ({
    ...state,
    isFetching: true
  }),
  [EstimatesActionTypes.GET_PDF_SUCCESS]: (
    state: EstimatesState,
    action: EstimatesAction
  ) => ({
    ...state,
    isFetching: false,
    // @ts-ignore
  }),
  [EstimatesActionTypes.GET_PDF_FAIL]: (state: EstimatesState) => ({
    ...state,
    isFetching: false
  }),
  [EstimatesActionTypes.GET_PDF_ON_EMAIL_REQUEST]: (state: EstimatesState) => ({
    ...state,
    isFetching: true
  }),
  [EstimatesActionTypes.GET_PDF_ON_EMAIL_SUCCESS]: (state: EstimatesState) => ({
    ...state,
    isFetching: false
  }),
  [EstimatesActionTypes.GET_PDF_ON_EMAIL_FAIL]: (state: EstimatesState) => ({
    ...state,
    isFetching: false
  })
})
